import { Dispatch } from 'redux';

import { MainStore } from '../store';

import routerHandlers from './modules/router';
import uiInjectHandlers from './modules/ui';

const handlers = {
    ...routerHandlers,
    ...uiInjectHandlers,
};

export default (store: MainStore) =>
    (next: Dispatch) =>
    (action: { type: keyof typeof handlers }): void => {
        if (action.type in handlers) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            handlers[action.type](store, next, action);
        } else {
            next(action);
        }
    };
